require('./autoCode/common/index.js')
require('./autoCode/interceptor/index.js')
import Vue from 'vue'
// 旧版代码没有严格的权限控制，为了兼容旧版代码，需要在不影响 Proxy 的使用的情况下，让框架不进行权限控制
window.noProxy = window.noProxy !== undefined ?  window.noProxy : !window.Proxy

/**
 * 数据访问权限
 * @param allowPath 允许访问的model的路径
 * @returns {function(*, *, *): *}
 * @constructor
 */
window.Model = function (allowPath) {
  return function (target, name, descriptor) {
    descriptor.value.allowPath = allowPath
    return descriptor.value
  }
}
const App = require('./autoCode/layout/index.vue').default // 使用 import 的话，layout 里就访问不到 Model 了
const router = require('./autoCode/auto-router.js').default
Vue.config.productionTip = false
App.router = router
// 如果有 vuex 的话自动引入 vuex
try {
  const Vuex = require('vuex')
  Vue.use(Vuex)
  App.store = new Vuex.Store({
    modules: (r => {
      let result = {}
      r.keys().forEach(key => {
        let item = r(key).default
        result[item.name] = item
      })
      return result
    })(require.context('../../../src', true, /store\.js$/))
  })
} catch (e) {
  // console.log('没有发现vuex', e)
}
new Vue(App).$mount('#app')
